window.mcb.forms.fields = window.mcb.forms.fields || {};
window.mcb.forms.fields.extensions = window.mcb.forms.fields.extensions || {};
window.mcb.forms.fields.extensions.choiceAsRadio = function (parent, shared) {
    const _logger = window.mcb.utilities.createLogger("forms.field.radio", 'Forms Field (Radio)');
    const _thisField = parent;
    const _shared = shared;
    let _validatedControlWrapper = null;
    const _controls = [];
    let _validationCanvas = null;

    {
        // Init
        _thisField.validation = {
            required: _thisField.settings.required ?? false,
            isSingleRequired: _thisField.settings.data.choices.length === 1 && _thisField.settings.required && _thisField.settings.title === null,
            dirty: false,
        };

        _thisField.rendering = {
            isHorizontal: typeof _thisField.settings.data.horizontal === "boolean" && _thisField.settings.data.horizontal === true
        }
    }

    const render = function (fieldGroup) {
        fieldGroup.classList.add(window.mcb.forms.constants.fields.classBaseDashed + 'radio');

        const wrapper = document.createElement('div');
        wrapper.classList.add(window.mcb.forms.constants.fields.collectionClass);
        wrapper.id = _thisField.fieldValuewrapperId;

        if (_thisField.rendering.isHorizontal) {
            wrapper.classList.add(window.mcb.forms.constants.fields.collectionHorizontalClass);
        }

        let index = 0;
        for (let choice of _thisField.settings.data.choices) {
            const item = document.createElement('div');
            item.classList.add(window.mcb.forms.constants.fields.collectionItemClass);
            wrapper.append(item);

            const label = document.createElement('label');
            label.title = choice.caption;
            item.append(label);

            const input = document.createElement('input');
            input.id = _thisField.fieldValueControlId + '_radio_' + index;
            input.dataset.index = index;
            input.classList.add(window.mcb.forms.constants.fields.uiInput);
            input.name = _thisField.alias;
            input.type = 'radio';
            input.value = choice.value;
            input.classList.add(window.mcb.forms.constants.fields.uiInput);

            if (choice.value === _thisField.settings.defaultValue) {
                input.checked = true;
                _thisField.validation.dirty = true;
            }

            label.append(input);

            _controls.push(input);
            index++;

            const text = document.createElement('span');
            text.append(choice.caption);

            if (_thisField.validation.isSingleRequired) {
                fieldGroup.classList.add(window.mcb.forms.constants.fields.requiredClass);
                const req = document.createElement('span');
                text.append(req);
                req.classList.add(window.mcb.forms.constants.fields.requiredMarkClass);
            }

            label.append(text);

            input.addEventListener('focus', (event) => {
                _logger.log(event.type, _thisField.alias, input.dataset.index, event);
                _shared.validateEvent(event, _thisField, input);
                _shared.fireFieldModifiedEvents(input, _thisField.applyValidationDuringInput);
            });

            input.addEventListener('change', (event) => {
                _logger.log(event.type, _thisField.alias, input.dataset.index, event);
                _shared.validateEvent(event, _thisField, input);
                _shared.fireFieldModifiedEvents(input, _thisField.applyValidationDuringInput);
            });

            input.addEventListener('blur', (event) => {
                _logger.log(event.type, _thisField.alias, input.dataset.index, event);
                _shared.validateEvent(event, _thisField, input);
                _shared.fireFieldModifiedEvents(input, _thisField.applyValidationDuringInput);
            });
        }

        _validationCanvas = document.createElement('div');
        _validationCanvas.classList.add(window.mcb.forms.constants.validation.validationTarget);

        _validatedControlWrapper = document.createElement('div');
        _validatedControlWrapper.classList.add(window.mcb.forms.constants.validation.validationWrapper);

        _validatedControlWrapper.appendChild(wrapper);
        _validatedControlWrapper.appendChild(_validationCanvas);

        return _validatedControlWrapper;
    };

    const getValue = function () {
        window.mcb.forms.validation.clearValidationResults(_validationCanvas);

        if (_validationCanvas === null) {
            throw new Error("Control is not initialized");
        }

        for (let i = 0; i < _controls.length; i++) {
            if (document.getElementById(_controls[i].id) === null) {
                throw new Error("Control has been removed from DOM");
            }
        }

        if (_validationCanvas.offsetParent === null) {
            // Field is not visible
            return undefined;
        }

        const values = [];
        for (let i = 0; i < _thisField.settings.data.choices.length; i++) {
            const control = _controls[i];
            if (control.checked) {
                values.push(_thisField.settings.data.choices[i].value);
            }
        }

        var value = values.join('|');

        const validation = new window.mcb.forms.validation.ValidationResult(true);
        if (_thisField.validation.required === true) {
            validation.aggregate(window.mcb.forms.validation.validateRequired(_thisField.alias, value));
        }

        if (values.length > 1) {
            validation.aggregate(new window.mcb.forms.validation.ValidationResult(false, "ChoiceHasTooManyValues", values));
        }

        validation.render(_thisField.formId, _validatedControlWrapper, _validationCanvas);
        if (validation.isValid()) {
            return value;
        }

        return null;
    };

    const setValue = function (value) {
        let isSet = false;
        for (let i = 0; i < _controls.length; i++) {
            const control = _controls[i];
            if (value === control.value) {
                control.checked = true;
                isSet = true;
                break;
            }
        }

        return isSet;
    }

    return _ = {
        render: render,
        getValue: getValue,
        setValue: setValue
    };
};
